import { makeStyles } from "@material-ui/core";
import { IWizardTitleConfig } from "../types";
import Typography from "@material-ui/core/Typography";
import React from "react";
import InfoIcon from "../../../components/InfoIcon";

const useIconBarStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing(3),
    height: theme.spacing(4),
    lineHeight: theme.spacing(4) + "px",
  },
  icon: {
    float: "left",
    marginRight: theme.spacing(1.5),
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  title: {
    height: theme.spacing(4),
    lineHeight: "inherit",
    fontFamily: "Roboto",
    fontSize: 20,
    fontWeight: "bold",
    color: "#535358",
    float: "left",
  },
}));

export default function IconBar({ titleText, info }: IWizardTitleConfig) {
  const classes = useIconBarStyles();

  return (
    <div className={classes.root}>
      {/* {Icon && <Icon className={classes.icon}/>} */}
      <Typography className={classes.title}>{titleText}</Typography>
      {info && <InfoIcon text={info} />}
    </div>
  );
}
